import { customTextBlock, heading, button } from "../../../text/nodes"
import { CTALeftHeaderImageRight as CTALeftHeaderImageRightEditor } from "./cta-left-header-image-right"
import { CTALeftHeaderImageRightSettings } from "./cta-left-header-image-right-settings"
import CTALeftHeaderImageRightPreview from "./cta-left-header-image-right-preview.png"

export const CTALeftHeaderImageRight = {
  name: "CTALeftHeaderImageRight",
  label: "call to action on left with header, image on right",
  EditorComponent: CTALeftHeaderImageRightEditor,
  SettingsComponent: CTALeftHeaderImageRightSettings,
  image: CTALeftHeaderImageRightPreview,
  defaultProperties: {
    backgroundColor: "#ffffff",
    headingColor: "#4d4d4d",
    image: "",
    alt: "",
    horizontalPadding: 24,
    verticalPadding: 24,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    imageBorderRadius: 0,
    columnRatio: 50,
    borderColor: "#e3e3e3",
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1
  },
  defaultChildren: [
    customTextBlock([
      heading(
        "three",
        "Orchids 101: How to keep that Trader Joe's impulse purchase alive\n"
      ),
      button("Buy now", {
        alignment: "left",
        roundedCornerOption: "full",
        size: "small"
      })
    ])
  ]
}
